import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { HttpResponseSuccess } from '@/services/service';
import {
	createOnboardingUser,
	OnboardingUserPayload,
	OnboardingUserResponse,
	ONBOARDING_USER_QUERY_KEY
} from '@/services/onboardingUserService';

export type { OnboardingUserResponse, OnboardingUserPayload };
export { ONBOARDING_USER_QUERY_KEY };

export const useCreateOnboardingUser = (): UseMutationResult<
	HttpResponseSuccess<OnboardingUserResponse>,
	Error,
	OnboardingUserPayload
> => {
	return useMutation({
		mutationFn: createOnboardingUser,
		onError: error => {
			throw new Error('Error creating user onboarding:', error);
		}
	});
};
